import { Link, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import ContentLayout from "studio-edifique/components/ContentLayout";
import FaqAccordionList from "studio-edifique/components/FaqAccordionList";
import ResponsiveImage from "studio-edifique/components/ResponsiveImage";
import NotFoundPage from "studio-edifique/pages/NotFoundPage";
import {
  servicePages,
  caseStudies,
  blogPosts,
  heroImages,
  company,
  getSiteUrl,
} from "studio-edifique/siteContent";

function ServicePage() {
  const { slug } = useParams();
  const service = servicePages.find((item) => item.slug === slug);
  if (!service) return <NotFoundPage />;
  const projects = caseStudies.filter((item) => service.projectSlugs.includes(item.slug));
  const articles = blogPosts.filter((item) => service.articleSlugs.includes(item.slug));
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: service.title,
    serviceType: service.name,
    description: service.description,
    url: getSiteUrl(`/servicos/${service.slug}`),
    areaServed: { "@type": "City", name: "Itatiba" },
    provider: { "@type": "Organization", name: company.brandName, url: company.siteUrl },
  };
  return (
    <ContentLayout
      title={service.title}
      description={service.description}
      intro={service.intro}
      eyebrow="Serviços · Itatiba e região"
      image={heroImages[service.heroKey]}
      imageAlt={`Acervo do Studio Edifique — ${service.name}`}
      parent={{ name: "Serviços", path: "/servicos" }}
      schema={[schema]}
    >
      <Grid container spacing={6}>
        <Grid item xs={12} md={8}>
          <MKBox component="section" mb={5}>
            <MKTypography variant="h3" component="h2" mb={2}>
              Para quem é este serviço
            </MKTypography>
            <MKTypography color="text" variant="body1">
              {service.audience}
            </MKTypography>
          </MKBox>
          {service.sections.map((section) => (
            <MKBox component="section" key={section.heading} mb={5}>
              <MKTypography variant="h3" component="h2" mb={2}>
                {section.heading}
              </MKTypography>
              <MKTypography color="text" variant="body1">
                {section.text}
              </MKTypography>
            </MKBox>
          ))}
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ p: 3 }}>
            <MKTypography variant="h4" component="h2" mb={2}>
              Como organizar a contratação
            </MKTypography>
            <MKBox component="ol" pl={3}>
              {service.deliverables.map((item) => (
                <MKTypography component="li" variant="body2" color="text" key={item} mb={2}>
                  {item}
                </MKTypography>
              ))}
            </MKBox>
            <MKTypography variant="h5" component="h3" mt={2} mb={2}>
              O que combinar na proposta
            </MKTypography>
            <MKTypography variant="body2" color="text">
              {service.limits}
            </MKTypography>
          </Card>
        </Grid>
      </Grid>
      {projects.length > 0 && (
        <MKBox component="section" mt={5}>
          <MKTypography variant="h3" component="h2" mb={3}>
            Conheça o trabalho no portfólio
          </MKTypography>
          <Grid container spacing={3}>
            {projects.map((project) => (
              <Grid item xs={12} md={6} key={project.slug}>
                <Card sx={{ p: 3 }}>
                  <ResponsiveImage src={project.cover} alt={project.title} />
                  <MKTypography variant="h4" component="h3" mt={3} mb={1}>
                    {project.title}
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={2}>
                    {project.mediaLabel}
                  </MKTypography>
                  <MKButton
                    component={Link}
                    to={`/projetos/${project.slug}`}
                    variant="outlined"
                    color="info"
                  >
                    Ver o projeto
                  </MKButton>
                </Card>
              </Grid>
            ))}
          </Grid>
        </MKBox>
      )}
      <MKBox component="section" mt={7}>
        <MKTypography variant="h3" component="h2" mb={3}>
          Perguntas sobre {service.name.toLowerCase()}
        </MKTypography>
        <FaqAccordionList items={service.faq} />
      </MKBox>
      <MKBox component="section" mt={6}>
        <MKTypography variant="h4" component="h2" mb={2}>
          Conteúdos para planejar o próximo passo
        </MKTypography>
        <MKBox component="ul" pl={3}>
          {articles.map((article) => (
            <MKBox component="li" key={article.slug} mb={1.5}>
              <MKTypography
                component={Link}
                to={`/blog/${article.slug}`}
                variant="body1"
                color="info"
              >
                {article.title}
              </MKTypography>
            </MKBox>
          ))}
        </MKBox>
        <MKTypography
          component={Link}
          to="/contato"
          variant="button"
          color="info"
          display="inline-block"
          mt={2}
        >
          Envie os dados da sua demanda →
        </MKTypography>
      </MKBox>
    </ContentLayout>
  );
}
export default ServicePage;
